export const initialFocusDataAttribute = 'data-modal-initial-focus';
export const initialFocusAttributes = {
	[initialFocusDataAttribute]: '',
};

export const closeButtonDataAttribute = 'data-modal-close-button';
export const closeButtonAttributes = {
	[closeButtonDataAttribute]: '',
};
